module.exports = __webpack_public_path__ + "img/60534A_211813_9B948E_8E837D-256px.70dc0141.png";